import { AssetVizColorProps } from '../defines'
import React from 'react'
import { useAssetVizTheme } from '../providers/theme'

/**
 * A hook which extracts colors from provided properties and memoizes them to
 * prevent frequent refreshes.
 * @param props           AssetViz props (this hook will only use a subset)
 * @param invertColors    Whether to invert colors or not (for screenshot mode)
 */
export const useExtractColors = (
  props: AssetVizColorProps,
  invertColors: boolean
) => {
  //----------------------------------------------------------------------------

  // This memoization is required since "theme" is regenerated all the time
  const theme = useAssetVizTheme()
  return React.useMemo(
    () => ({
      assetColorString: invertColors
        ? theme.activeText
        : (props.assetColor ?? theme.background3),
      weldColorString: theme.secondaryText,
      corrosionRegionColorString: theme.activeText ?? theme.secondaryText,
      featureLabelColorString: invertColors
        ? theme.background1
        : theme.activeText,
      gridColorString:
        props.gridColor ??
        (invertColors ? theme.background1 : theme.defaultText),
      draftSelectionColorString: props.outlineColor ?? theme.secondaryText,
      selectionColorString: props.outlineColor ?? theme.border,
      backgroundColorString: invertColors
        ? theme.activeText
        : (props.backgroundColor ?? ''),
      labelBackgroundColorString: invertColors
        ? theme.defaultText
        : theme.background2,
    }),
    [
      props.assetColor,
      props.backgroundColor,
      props.gridColor,
      props.outlineColor,
      invertColors,
      theme,
    ]
  )
}
